import * as React from 'react';
import { Col, Container, Row } from 'reactstrap';
import FAIcon from 'src/components/fAIcon/FAIcon';
import { IEmptyProps } from 'src/constants';
import { TR } from 'src/TextRes';
import {
    ApiBasedataList,
    ApiCourseProvidersImageUpload,
    ApiCourseProvidersLoadmine,
    ApiCourseProvidersSavemine,
    ApiUsersSavePassword,
    ApiUsersSaveUsername,
    BasedataEntryParams,
    BasedataParams,
    CourseProviderData,
    CourseProviderEdit,
    CoursesProviderLoadMineResult,
    ServerResponse,
    UploadImage,
    UserData,
} from '../../api';
import CPHeaderLoggedIn from '../../components/cpHeaderLoggedIn/CPHeaderLoggedIn';
import CPAccount from '../../components/cpProfileComponent/CPAccount';
import CPAdress from '../../components/cpProfileComponent/CPAdress';
import CPBaseData from '../../components/cpProfileComponent/CPBaseData';
import CPBookingTerms from '../../components/cpProfileComponent/CPBookingTerms';
import CPContactingFromWhere from '../../components/cpProfileComponent/CPContactingFromWhere';
import CPInvoiceData from '../../components/cpProfileComponent/CPInvoiceData';
import CPName from '../../components/cpProfileComponent/CPName';
import CPPersonalData from '../../components/cpProfileComponent/CPPersonalData';
import CPProfileImage from '../../components/cpProfileComponent/CPProfileImage';
import TextAreaEditInput from '../../components/cpProfileComponent/TextAreaEditInput';
import Footer from '../../components/footer/Footer';
import NetworkOverlay from '../../components/networkOverlay/NetworkOverlay';

interface CPProfileState {
    loading: boolean;
    techniques: BasedataParams;
    topics: BasedataParams;
    categories: BasedataParams;
    serverResponse?: ServerResponse;
    currentlyEditing: string | undefined;
    courseProviderEdit: CourseProviderEdit;
    courseProviderData: CourseProviderData;
    user: UserData;
    imageData?: string;
}
export interface CourseProviderUser {
    Email: string;
    Password: string;
}

export enum EditingName {
    PersonalData = 'personalData',
    CPName = 'cpName',
    CPDescription = 'description',
    Categories = 'categories',
    Techniques = 'techniques',
    Topics = 'topics',
    Account = 'account',
    Adress = 'adress',
    InvoiceData = 'invoiceData',
    BookingTerms = 'bookingTerms',
    ProfileImage = 'profileImage',
}

export default class CPProfile extends React.Component<IEmptyProps, CPProfileState> {
    constructor(props: IEmptyProps) {
        super(props);
        this.state = {
            categories: {
                Data: [],
                Key: '',
                Name: '',
            },
            courseProviderData: {
                AcceptedPrivacy: false,
                Commission: 0,
                Disabled: false,
                ProfileImage: undefined,
                PublicUrl: '',
                Imported: false,
            },
            courseProviderEdit: {
                AcceptedTerms: '',
                BookingTerms: '',
                Categories: [],
                City: '',
                CompanyName: '',
                ContactPersonFirstName: '',
                ContactPersonLastName: '',
                ContactPersonSalutation: '',
                ContactingFromWhere: '',
                Country: '',
                Description: '',
                Email: '',
                InvoiceAddress: false,
                InvoiceCity: '',
                InvoiceCompany: '',
                InvoiceCountry: '',
                InvoiceFirstName: '',
                InvoiceLastName: '',
                InvoiceStreet: '',
                InvoiceZip: '',
                Lecturers: [],
                Locations: [],
                Name: '',
                Referral: false,
                Street: '',
                Techniques: [],
                Telephone: '',
                Topics: [],
                Vat: '',
                Website: '',
                Zip: '',
            },
            currentlyEditing: undefined,
            loading: true,
            serverResponse: undefined,
            techniques: {
                Data: [],
                Key: '',
                Name: '',
            },
            topics: {
                Data: [],
                Key: '',
                Name: '',
            },
            user: {
                Email: '',
                Firstname: '',
                Gender: '',
                Lastname: '',
            },
            imageData: undefined,
        };
    }

    public componentDidMount() {
        ApiBasedataList((sr) => {
            if (sr.OK && sr.Data) {
                let techniquesBaseData: BasedataParams = { Data: [], Key: '', Name: '' };
                let categoriesBaseData: BasedataParams = { Data: [], Key: '', Name: '' };
                let topicsBaseData: BasedataParams = { Data: [], Key: '', Name: '' };
                sr.Data.Basedata.map((s: BasedataParams) => {
                    switch (s.Key) {
                        case EditingName.Categories:
                            categoriesBaseData = s;
                            break;
                        case EditingName.Techniques:
                            techniquesBaseData = s;
                            break;
                        case EditingName.Topics:
                            topicsBaseData = s;
                            break;
                    }
                });
                this.setState(
                    { categories: categoriesBaseData, techniques: techniquesBaseData, topics: topicsBaseData },
                    () => {
                        ApiCourseProvidersLoadmine(
                            (cpsr: ServerResponse & { Data?: CoursesProviderLoadMineResult }) => {
                                if (cpsr.OK && cpsr.Data) {
                                    this.setState({
                                        courseProviderData: cpsr.Data.CourseProviderData,
                                        courseProviderEdit: cpsr.Data.CourseProviderEdit,
                                        loading: false,
                                        user: cpsr.Data.User,
                                    });
                                } else {
                                    this.setState({ serverResponse: cpsr });
                                }
                            }
                        );
                    }
                );
            } else {
                this.setState({ serverResponse: sr });
            }
        });
    }

    public render() {
        return (
            <NetworkOverlay loading={this.state.loading} serverResponse={this.state.serverResponse}>
                <CPHeaderLoggedIn />
                {!this.state.loading && (
                    <Container>
                        <Row>
                            <Col md={9}>
                                {!this.state.courseProviderEdit.Referral &&
                                    this.state.courseProviderEdit.ContactingFromWhere !== 'import' && (
                                        <CPContactingFromWhere
                                            saveContactingFromWhere={(a: string) => {
                                                if (a.length >= 3) {
                                                    const courseProviderEdit = Object.assign(
                                                        this.state.courseProviderEdit,
                                                        {
                                                            ContactingFromWhere: a,
                                                            Referral: true,
                                                        }
                                                    );
                                                    this.courseProviderEditSave(courseProviderEdit);
                                                }
                                            }}
                                        />
                                    )}
                                <CPName
                                    courseProvider={this.state.courseProviderEdit}
                                    cancelHandler={() =>
                                        this.setState({
                                            currentlyEditing: undefined,
                                        })
                                    }
                                    saveCourseProviderName={(a: string) => {
                                        const courseProviderEdit = Object.assign(this.state.courseProviderEdit, {
                                            Name: a,
                                        });
                                        this.courseProviderEditSave(courseProviderEdit);
                                    }}
                                    editHandler={() => {
                                        this.setState({ currentlyEditing: EditingName.CPName });
                                    }}
                                    editItemKey={this.state.currentlyEditing}
                                />
                                <CPPersonalData
                                    courseProvider={this.state.courseProviderEdit}
                                    cancelHandler={() =>
                                        this.setState({
                                            currentlyEditing: undefined,
                                        })
                                    }
                                    savePersonalData={(
                                        a: string,
                                        b: string,
                                        c: string,
                                        d: string,
                                        e: string,
                                        f: string
                                    ) => {
                                        const courseProviderEdit = Object.assign(this.state.courseProviderEdit, {
                                            ContactPersonFirstName: a,
                                            ContactPersonLastName: b,
                                            ContactPersonSalutation: c,
                                            Email: d,
                                            Telephone: e,
                                            Website: f,
                                        });
                                        this.courseProviderEditSave(courseProviderEdit);
                                    }}
                                    editHandler={() => {
                                        this.setState({ currentlyEditing: EditingName.PersonalData });
                                    }}
                                    editItemKey={this.state.currentlyEditing}
                                />
                                <CPAdress
                                    courseProvider={this.state.courseProviderEdit}
                                    cancelHandler={() =>
                                        this.setState({
                                            currentlyEditing: undefined,
                                        })
                                    }
                                    saveAdress={(
                                        a: string,
                                        b: string,
                                        c: string,
                                        d: boolean,
                                        e: string,
                                        f: string,
                                        g: string,
                                        h: string,
                                        i: string,
                                        j: string,
                                        k: string,
                                        l: string,
                                        m: string
                                    ) => {
                                        const courseProviderEdit = Object.assign(this.state.courseProviderEdit, {
                                            City: a,
                                            CompanyName: b,
                                            Country: c,
                                            InvoiceAddress: d,
                                            InvoiceCity: e,
                                            InvoiceCompany: f,
                                            InvoiceCountry: g,
                                            InvoiceFirstName: h,
                                            InvoiceLastName: i,
                                            InvoiceStreet: j,
                                            InvoiceZip: k,
                                            Street: l,
                                            Zip: m,
                                        });
                                        this.courseProviderEditSave(courseProviderEdit);
                                    }}
                                    editHandler={() => {
                                        this.setState({ currentlyEditing: EditingName.Adress });
                                    }}
                                    editItemKey={this.state.currentlyEditing}
                                />
                                <TextAreaEditInput
                                    name={TR.cPProfile_description}
                                    textDefaultValue={this.state.courseProviderEdit.Description}
                                    textTitleValue={TR.cPProfile_description_help}
                                    cancelHandler={() =>
                                        this.setState({
                                            currentlyEditing: undefined,
                                        })
                                    }
                                    saveHandler={(a: string) => {
                                        const courseProviderEdit = Object.assign(this.state.courseProviderEdit, {
                                            Description: a,
                                        });
                                        this.courseProviderEditSave(courseProviderEdit);
                                    }}
                                    editHandler={() => {
                                        this.setState({ currentlyEditing: EditingName.CPDescription });
                                    }}
                                    editName={EditingName.CPDescription}
                                    editItemKey={this.state.currentlyEditing}
                                />
                                <CPBookingTerms
                                    courseProvider={this.state.courseProviderEdit}
                                    cancelHandler={() =>
                                        this.setState({
                                            currentlyEditing: undefined,
                                        })
                                    }
                                    saveBookingTerms={(a: string) => {
                                        const courseProviderEdit = Object.assign(this.state.courseProviderEdit, {
                                            BookingTerms: a,
                                        });
                                        this.courseProviderEditSave(courseProviderEdit);
                                    }}
                                    editHandler={() => {
                                        this.setState({ currentlyEditing: EditingName.BookingTerms });
                                    }}
                                    editItemKey={this.state.currentlyEditing}
                                />
                                <CPInvoiceData
                                    courseProvider={this.state.courseProviderEdit}
                                    courseProviderData={this.state.courseProviderData}
                                    cancelHandler={() =>
                                        this.setState({
                                            currentlyEditing: undefined,
                                        })
                                    }
                                    saveInvoiceData={(a: string) => {
                                        const courseProviderEdit = Object.assign(this.state.courseProviderEdit, {
                                            Vat: a,
                                        });
                                        this.courseProviderEditSave(courseProviderEdit);
                                    }}
                                    editHandler={() => {
                                        this.setState({ currentlyEditing: EditingName.InvoiceData });
                                    }}
                                    editItemKey={this.state.currentlyEditing}
                                />
                                <CPBaseData
                                    baseDataFromServer={this.state.techniques}
                                    baseDataFromCP={this.courseProviderBaseData(EditingName.Techniques)}
                                    cancelHandler={() =>
                                        this.setState({
                                            currentlyEditing: undefined,
                                        })
                                    }
                                    textMessage={TR.cPProfile_techniques}
                                    saveBaseData={(n: number[]) => {
                                        const courseProviderEdit = Object.assign(this.state.courseProviderEdit, {
                                            Techniques: n,
                                        });
                                        this.courseProviderEditSave(courseProviderEdit);
                                    }}
                                    editHandler={() => {
                                        this.setState({
                                            currentlyEditing: EditingName.Techniques,
                                        });
                                    }}
                                    editItemKey={this.state.currentlyEditing}
                                />
                                <CPBaseData
                                    baseDataFromServer={this.state.categories}
                                    baseDataFromCP={this.courseProviderBaseData(EditingName.Categories)}
                                    cancelHandler={() =>
                                        this.setState({
                                            currentlyEditing: undefined,
                                        })
                                    }
                                    textMessage={TR.cPProfile_categories}
                                    saveBaseData={(n: number[]) => {
                                        const courseProviderEdit = Object.assign(this.state.courseProviderEdit, {
                                            Categories: n,
                                        });
                                        this.courseProviderEditSave(courseProviderEdit);
                                    }}
                                    editHandler={() => {
                                        this.setState({
                                            currentlyEditing: EditingName.Categories,
                                        });
                                    }}
                                    editItemKey={this.state.currentlyEditing}
                                />
                                <CPBaseData
                                    baseDataFromServer={this.state.topics}
                                    baseDataFromCP={this.courseProviderBaseData(EditingName.Topics)}
                                    cancelHandler={() =>
                                        this.setState({
                                            currentlyEditing: undefined,
                                        })
                                    }
                                    textMessage={TR.cPProfile_topics}
                                    saveBaseData={(n: number[]) => {
                                        const courseProviderEdit = Object.assign(this.state.courseProviderEdit, {
                                            Topics: n,
                                        });
                                        this.courseProviderEditSave(courseProviderEdit);
                                    }}
                                    editHandler={() => {
                                        this.setState({
                                            currentlyEditing: EditingName.Topics,
                                        });
                                    }}
                                    editItemKey={this.state.currentlyEditing}
                                />
                                <CPAccount
                                    courseProviderUser={this.state.user}
                                    cancelHandler={() =>
                                        this.setState({
                                            currentlyEditing: undefined,
                                        })
                                    }
                                    saveAccountMail={this.saveAccountMail}
                                    saveAccountPassword={this.saveAccountPassword}
                                    clearErrors={() => {
                                        this.setState({ serverResponse: undefined });
                                    }}
                                    editHandler={() => {
                                        this.setState({
                                            currentlyEditing: EditingName.Account,
                                            serverResponse: undefined,
                                        });
                                    }}
                                    editItemKey={this.state.currentlyEditing}
                                    serverResponse={
                                        this.state.currentlyEditing === 'account' &&
                                        this.state.serverResponse !== undefined
                                            ? this.state.serverResponse
                                            : undefined
                                    }
                                />
                                {this.state.courseProviderData.PublicUrl && this.state.courseProviderData.Disabled && (
                                    <Row className="mt-2 mb-4 CPItemEditComponent">
                                        <Col>
                                            <h4 className={'cpitemwarning'}>
                                                <FAIcon icon="exclamation-triangle" /> {TR.cPProfile_locked}
                                            </h4>
                                        </Col>
                                    </Row>
                                )}
                                {!this.state.courseProviderData.Published &&
                                    !this.state.courseProviderData.Disabled && (
                                        <Row className="mt-2 mb-4 CPItemEditComponent">
                                            <Col>{TR.cPProfile_not_complete}</Col>
                                        </Row>
                                    )}
                                {!this.state.courseProviderData.Disabled &&
                                    this.state.courseProviderData.Published &&
                                    this.state.courseProviderData.NeedsSync &&
                                    this.state.courseProviderData.SyncError === '' && (
                                        <Row className="mt-2 mb-4 CPItemEditComponent">
                                            <Col>{TR.cPProfile_in_transit}</Col>
                                        </Row>
                                    )}
                                {this.state.courseProviderData.PublicUrl &&
                                    !this.state.courseProviderData.Disabled &&
                                    this.state.courseProviderData.Published &&
                                    !this.state.courseProviderData.NeedsSync &&
                                    this.state.courseProviderData.SyncError === '' && (
                                        <Row className="mt-2 mb-4 CPItemEditComponent">
                                            <Col>
                                                <h4>{TR.cPProfile_link_to_profile}</h4>
                                                <a target="_blank" href={this.state.courseProviderData.PublicUrl}>
                                                    {this.state.courseProviderData.PublicUrl}
                                                </a>
                                            </Col>
                                        </Row>
                                    )}
                                {this.state.courseProviderData.PublicUrl &&
                                    !this.state.courseProviderData.Disabled &&
                                    this.state.courseProviderData.SyncError !== '' && (
                                        <Row className="mt-2 mb-4 CPItemEditComponent">
                                            <Col>
                                                <h4 className={'cpitemwarning'}>
                                                    <FAIcon icon="exclamation-triangle" /> {TR.cPProfile_try_again}
                                                </h4>
                                            </Col>
                                        </Row>
                                    )}
                            </Col>
                            <Col>
                                <CPProfileImage
                                    editItemKey={this.state.currentlyEditing}
                                    cancelHandler={() =>
                                        this.setState({
                                            currentlyEditing: undefined,
                                        })
                                    }
                                    editHandler={() => {
                                        this.setState({ currentlyEditing: EditingName.ProfileImage });
                                    }}
                                    saveHandler={this.courseProviderProfileImageUpload}
                                    image={this.state.courseProviderData.ProfileImage}
                                />
                            </Col>
                        </Row>
                    </Container>
                )}
                <Footer />
            </NetworkOverlay>
        );
    }

    private courseProviderBaseData(str: string) {
        const myBaseDte: BasedataParams = {
            Data: [],
            Key: str,
            Name: str,
        };
        if (this.state.courseProviderEdit && str === EditingName.Categories) {
            this.state.courseProviderEdit.Categories.map((n: number) => {
                this.state.categories.Data.map((d: BasedataEntryParams) => {
                    if (d.ID === n) {
                        myBaseDte.Data.push(d);
                    }
                });
            });
            return myBaseDte;
        } else if (this.state.courseProviderEdit && str === EditingName.Techniques) {
            this.state.courseProviderEdit.Techniques.map((n: number) => {
                this.state.techniques.Data.map((d: BasedataEntryParams) => {
                    if (d.ID === n) {
                        myBaseDte.Data.push(d);
                    }
                });
            });
            return myBaseDte;
        } else if (this.state.courseProviderEdit && str === EditingName.Topics) {
            this.state.courseProviderEdit.Topics.map((n: number) => {
                this.state.topics.Data.map((d: BasedataEntryParams) => {
                    if (d.ID === n) {
                        myBaseDte.Data.push(d);
                    }
                });
            });
            return myBaseDte;
        }

        return myBaseDte;
    }

    private courseProviderProfileImageUpload = (image?: UploadImage) => {
        if (image === undefined) {
            this.setState({ currentlyEditing: undefined });
        } else {
            this.setState({ loading: true }, () => {
                ApiCourseProvidersImageUpload(image, (sr) => {
                    if (sr.OK) {
                        const cpd = this.state.courseProviderData;
                        cpd.ProfileImage = sr.Data;
                        this.setState({ loading: false, courseProviderData: cpd, currentlyEditing: undefined });
                    } else {
                        this.setState({ loading: false, serverResponse: sr });
                    }
                });
            });
        }
    };

    private courseProviderEditSave = (courseProvider: CourseProviderEdit) => {
        ApiCourseProvidersSavemine(
            courseProvider,
            (cpsr: ServerResponse & { Data?: CoursesProviderLoadMineResult }) => {
                if (cpsr.OK && cpsr.Data) {
                    this.setState({
                        courseProviderData: cpsr.Data.CourseProviderData,
                        courseProviderEdit: cpsr.Data.CourseProviderEdit,
                        currentlyEditing: undefined,
                        user: cpsr.Data.User,
                    });
                } else {
                    this.setState({ serverResponse: cpsr });
                }
            }
        );
    };

    private saveAccountMail = (mail: string) => {
        ApiUsersSaveUsername({ Username: mail }, (sr) => {
            if (sr.OK) {
                this.setState({
                    currentlyEditing: undefined,
                    user: Object.assign(this.state.user, {
                        Email: mail,
                    }),
                });
            } else {
                this.setState({ serverResponse: sr });
            }
        });
    };

    private saveAccountPassword = (password: string) => {
        ApiUsersSavePassword({ Password: password }, (sr) => {
            if (sr.OK) {
                this.setState({
                    currentlyEditing: undefined,
                });
            } else {
                this.setState({ serverResponse: sr });
            }
        });
    };
}



// WEBPACK FOOTER //
// ./src/views/cpProfile/CPProfile.tsx